
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/como-funciona",
      function () {
        return require("private-next-pages/como-funciona.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/como-funciona"])
      });
    }
  